/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CreateAnnouncementNotificationDto } from '../model';
// @ts-ignore
import type { GetUserNotificationsResponseDto } from '../model';
// @ts-ignore
import type { UnreadCountResponseDto } from '../model';
/**
 * NotificationsApi - axios parameter creator
 * @export
 */
export const NotificationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a global announcement notification
         * @param {CreateAnnouncementNotificationDto} createAnnouncementNotificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerCreateAnnouncementNotification: async (createAnnouncementNotificationDto: CreateAnnouncementNotificationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAnnouncementNotificationDto' is not null or undefined
            assertParamExists('notificationsControllerCreateAnnouncementNotification', 'createAnnouncementNotificationDto', createAnnouncementNotificationDto)
            const localVarPath = `/api/notifications/announcements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAnnouncementNotificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get unread notification count for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerGetUnreadNotificationCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/unread-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all notifications for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerGetUserNotifications: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark all notifications as read for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerMarkAllNotificationsAsRead: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/notifications/mark-all-read`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark a specific notification as read
         * @param {string} id Notification ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerMarkNotificationAsRead: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('notificationsControllerMarkNotificationAsRead', 'id', id)
            const localVarPath = `/api/notifications/{id}/read`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationsApi - functional programming interface
 * @export
 */
export const NotificationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a global announcement notification
         * @param {CreateAnnouncementNotificationDto} createAnnouncementNotificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsControllerCreateAnnouncementNotification(createAnnouncementNotificationDto: CreateAnnouncementNotificationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsControllerCreateAnnouncementNotification(createAnnouncementNotificationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.notificationsControllerCreateAnnouncementNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get unread notification count for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsControllerGetUnreadNotificationCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnreadCountResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsControllerGetUnreadNotificationCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.notificationsControllerGetUnreadNotificationCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all notifications for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsControllerGetUserNotifications(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserNotificationsResponseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsControllerGetUserNotifications(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.notificationsControllerGetUserNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark all notifications as read for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsControllerMarkAllNotificationsAsRead(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsControllerMarkAllNotificationsAsRead(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.notificationsControllerMarkAllNotificationsAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark a specific notification as read
         * @param {string} id Notification ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationsControllerMarkNotificationAsRead(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationsControllerMarkNotificationAsRead(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationsApi.notificationsControllerMarkNotificationAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationsApi - factory interface
 * @export
 */
export const NotificationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a global announcement notification
         * @param {CreateAnnouncementNotificationDto} createAnnouncementNotificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerCreateAnnouncementNotification(createAnnouncementNotificationDto: CreateAnnouncementNotificationDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notificationsControllerCreateAnnouncementNotification(createAnnouncementNotificationDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get unread notification count for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerGetUnreadNotificationCount(options?: RawAxiosRequestConfig): AxiosPromise<UnreadCountResponseDto> {
            return localVarFp.notificationsControllerGetUnreadNotificationCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all notifications for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerGetUserNotifications(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetUserNotificationsResponseDto>> {
            return localVarFp.notificationsControllerGetUserNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark all notifications as read for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerMarkAllNotificationsAsRead(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notificationsControllerMarkAllNotificationsAsRead(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark a specific notification as read
         * @param {string} id Notification ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsControllerMarkNotificationAsRead(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.notificationsControllerMarkNotificationAsRead(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationsApi - object-oriented interface
 * @export
 * @class NotificationsApi
 * @extends {BaseAPI}
 */
export class NotificationsApi extends BaseAPI {
    /**
     * 
     * @summary Create a global announcement notification
     * @param {CreateAnnouncementNotificationDto} createAnnouncementNotificationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationsControllerCreateAnnouncementNotification(createAnnouncementNotificationDto: CreateAnnouncementNotificationDto, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationsControllerCreateAnnouncementNotification(createAnnouncementNotificationDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get unread notification count for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationsControllerGetUnreadNotificationCount(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationsControllerGetUnreadNotificationCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all notifications for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationsControllerGetUserNotifications(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationsControllerGetUserNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark all notifications as read for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationsControllerMarkAllNotificationsAsRead(options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationsControllerMarkAllNotificationsAsRead(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark a specific notification as read
     * @param {string} id Notification ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationsApi
     */
    public notificationsControllerMarkNotificationAsRead(id: string, options?: RawAxiosRequestConfig) {
        return NotificationsApiFp(this.configuration).notificationsControllerMarkNotificationAsRead(id, options).then((request) => request(this.axios, this.basePath));
    }
}

